import http from "services/http";

export interface Expense {
  _id: string;
  amount: number;
  description: string;
  category: string;
  date: string;
  paidBy: string;
  receipt: string;
  notes: string;
  recordedBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface ExpensesResponse {
  success: boolean;
  message: string;
  data: {
    expenses: Expense[];
    totalAmount: number;
    pagination?: {
      page: number;
      limit: number;
      total: number;
      pages: number;
    };
  };
}

export const getExpenses = async (): Promise<ExpensesResponse> => {
  const response = await http.get("/admin/expenses");
  return response.data;
};

export interface CreateExpensePayload {
  receipt?: File | null;
  date: string;
  amount: number;
  description: string;
  category: string;
  paidBy: string;
  notes?: string;
  recordedBy: string;
}

export interface CreateExpenseResponse {
  success: boolean;
  message: string;
  data?: {
    expense?: Expense;
  };
}

export const createExpense = async (
  payload: CreateExpensePayload,
): Promise<CreateExpenseResponse> => {
  const formData = new FormData();
  if (payload.receipt) {
    formData.append("receipt", payload.receipt);
  }
  formData.append("date", payload.date);
  formData.append("amount", String(payload.amount));
  formData.append("description", payload.description);
  formData.append("category", payload.category);
  formData.append("paidBy", payload.paidBy);
  if (payload.notes) {
    formData.append("notes", payload.notes);
  }
  formData.append("recordedBy", payload.recordedBy);

  const response = await http.post("/admin/expenses", formData);
  return response.data;
};
